export default __webpack_public_path__ + "static/media/satking icon white.b68e7838.svg";